import { render, staticRenderFns } from "./productSpec__form.vue?vue&type=template&id=17cc7074"
import script from "./productSpec__form.vue?vue&type=script&lang=js"
export * from "./productSpec__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports